import { SearchTerm } from './SearchTerm';

const DiscoverBiometric: SearchTerm[] = [
    // {
    //     heading: "Address",
    //     accessor: "address",
    //     searchOnName: "address",
    //     translationKey: "address"
    // },
    {
        heading: "Serial",
        accessor: "serialAddress",
        searchOnName: "serialAddress",
        translationKey: "serial"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "ipAddress",
        translationKey: "ip"
    },
    {
        heading: "Version",
        accessor: "version",
        searchOnName: "version",
        translationKey: "version"
    },
    {
        heading: "Model",
        accessor: "baseDeviceName",
        searchOnName: "baseDeviceName",
        translationKey: "model"
    }
]

export default DiscoverBiometric;
